<template>
  <div>
    <div class="reason-option-item-header" v-if="item.description !== null">
      <div class="reason-option-item-description">
        <vs-input 
          :name="componentName"
          v-validate="validateCustom ? validateCustom :'required'"
          class="mb-1 w-full"
          label-placeholder="Descrição" 
          v-model="item.description"
          :maxlength="lengthMax"
        ></vs-input>
      </div>

      <div v-if="ableToRemove" class="btn-container">
          <feather-icon
            icon="TrashIcon"
            class="ml-2 mr-1 mt-4 "
            svgClasses="w-6 h-6 text-danger stroke-current hover:text-dark"
            @click.prevent="remove"
          />
      </div>
    </div>
    <span v-if="lengthMax" class="text-sm"> Caracteres: {{item.description.length}}/{{ lengthMax }}</span>
  </div>
</template>
<script>
  export default {
    name: 'reason-option-items-item',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      ableToRemove: {
        type: Boolean,
        required: false
      },
      lengthMax: {
        type: Number,
        required: false
      },
      componentName: {
        type: String,
        required: false,
        default() {
          return 'description';
        }
      },
      validateCustom: {
        type: String,
        required: false,
      },
      item: {
        type: Object,
        required: false,
        default(){
          return {
            description: null
          }
        }
      }
    },
    data() {
      return {
        id: null,
        show: true,
      }
    },
    methods: {
      confirmRemoveReasonOptionItem (identifier) {
        if (identifier === this.identifier) {
          this.remove()
        }
      },
      remove () {
        this.$emit('onRemoveReasonOptionItem', this.index)
      },
    }
  }
</script>
<style lang="scss" scoped>
  .btn-container {
    margin-top: 3px;
  }

  .reason-option-item-header {
    display: flex;
    align-items: center;
  }

  .reason-option-item-description {
    flex-grow: 1;
  }
</style>
